import React from "react";
import { Change, SizedPrice, Variant } from "@bloomberg/media-ui-markets";
import styles from "./currentPrice.module.css";
import PriceDelta from "~components/PriceDelta";

export type CurrentPriceProps = {
  currentPrice: number;
  percentChange: number;
  priceChange: number;
  issuedUnits?: string;
  issuedCurrency?: string;
  isRealTime: boolean;
};

export default function CurrentPrice(props: CurrentPriceProps) {
  const {
    currentPrice,
    percentChange,
    priceChange,
    issuedUnits,
    issuedCurrency,
    isRealTime,
  } = props;

  const shouldShowChange = percentChange !== null && priceChange !== null;

  if (!currentPrice && !percentChange && !priceChange) {
    return null;
  }

  return (
    <div className={styles.currentPriceContainer}>
      {currentPrice && !isRealTime && (
        <SizedPrice price={currentPrice} size="extraLarge" />
      )}
      {currentPrice && isRealTime && <PriceDelta price={currentPrice} />}
      {!issuedCurrency && issuedUnits && (
        <span className={styles.units}>{issuedUnits}</span>
      )}

      {shouldShowChange && (
        <Change
          className={styles.change}
          name="change"
          percentChange={percentChange}
          priceChange={priceChange}
          size="large"
          variant={Variant.refresh2024}
        />
      )}
    </div>
  );
}
